module.exports = __webpack_public_path__ + "img/circle-ring.6517a88d.png";